export const isEmptyObject = (obj: object) => Object.keys(obj).length === 0;

export default isEmptyObject;
